import {Grow} from '@aboutyou/transitions';
import {COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CouponDeepLinkActivationStatus} from './CouponDeepLinkActivation';

const ERROR_ANIMATION_DURATION = 700;

interface CouponIconProps {
  className?: string;
  status: CouponDeepLinkActivationStatus;
}

export const CouponIcon: React.FC<CouponIconProps> = ({className, status}) => {
  return (
    <Wrapper className={className}>
      <Coupon
        data-animation-type={status}
        asset={
          status === 'paused' ? GenericIconName.Pause : GenericIconName.Coupon
        }
        size="XL"
        fill={COLORS.White}
      />
      <Grow
        mounted={status === 'error'}
        direction="center"
        duration={300}
        delay={ERROR_ANIMATION_DURATION}
      >
        <InfoIconWrapper>
          <Icon asset={GenericIconName.Error} size="S" fill="#8FC2FF" />
        </InfoIconWrapper>
      </Grow>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background-color: ${COLORS.PrimaryCoupon};
  border-radius: 50px;
`;

const Coupon = styled(Icon)`
  @keyframes bounceY {
    0% {
      transform: scale(1, 1) translateY(0);
    }
    10% {
      transform: scale(1.1, 0.9) translateY(0);
    }
    30% {
      transform: scale(0.9, 1.1) translateY(-14px);
    }
    40% {
      transform: scale(1.05, 0.95) translateY(0);
    }
    45% {
      transform: scale(1, 1) translateY(-3px);
    }
    50% {
      transform: scale(1, 1) translateY(0);
    }
    100% {
      transform: scale(1, 1) translateY(0);
    }
  }

  @keyframes bounceX {
    0% {
      transform: translateX(0);
    }
    40% {
      transform: translateX(8px);
    }
    70% {
      transform: translateX(-8px);
    }
    100% {
      transform: translateX(0);
    }
  }

  &[data-animation-type='loading'] {
    animation-name: bounceY;
    animation-timing-function: ease-in-out;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }

  &[data-animation-type='error'] {
    animation-name: bounceX;
    animation-timing-function: linear;
    animation-duration: ${ERROR_ANIMATION_DURATION}ms;
    animation-iteration-count: 1;
  }
`;

const InfoIconWrapper = styled.span`
  position: absolute;
  top: 20px;
  right: 15px;
`;
